import ProfileService from '_src/common/service/profileService';

class Country {
  constructor() {
    this.countryList = null;
    this.isPending = false;
    this.getCountryCallbacks = [];
  }

  dispatch() {
    this.getCountryCallbacks.forEach((cb) => {
      return cb(this.countryList || []);
    });
    this.getCountryCallbacks = [];
  }

  async getCountryList(cb) {
    this.getCountryCallbacks.push(cb);

    if (this.countryList) {
      this.dispatch();
      return;
    }

    if (!this.isPending) {
      this.isPending = true;
      try {
        const res = await ProfileService.getCountryList();
        this.countryList = res.data.map((T) => {
          return {
            value: T.code,
            label: T.name,
            disabled: T.withdrawStatus === '0',
            hasNext: T.hasNext === '1',
          };
        });
      } finally {
        this.isPending = false;
        this.dispatch();
      }
    }
  }
}

const country = new Country();
export default country;
